import { render, staticRenderFns } from "./TsnyModal.vue?vue&type=template&id=68a93916&scoped=true&"
import script from "./TsnyModal.vue?vue&type=script&lang=js&"
export * from "./TsnyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a93916",
  null
  
)

export default component.exports